import type { PortfolioData } from '../domain/portfolio.types';

export function Services({ data }: { data: PortfolioData }) {
  return (
    <section className="section" id="services">
      <span className="kanji-watermark" style={{ fontSize: 'clamp(160px, 28vw, 480px)', bottom: '40px', left: '-40px' }}>業</span>
      <div className="container">
        <div className="reveal" style={{ marginBottom: 56 }}>
          <div className="section-tag">05 · Services</div>
          <h2 className="section-title">
            What I'm <span className="alt">paid</span> to do.
          </h2>
          <p className="section-sub">Three modes of engagement. Most projects mix all three.</p>
        </div>
        <div className="services-grid reveal">
          {data.services.map((s, i) => (
            <div className="service-card" key={i}>
              <div className="service-num">
                <span>SVC / {s.num}</span>
                <span className="meta">SERVICE</span>
              </div>
              <h3 className="service-name">{s.name}</h3>
              <p className="service-blurb">{s.blurb}</p>
              <ul className="service-list">
                {s.list.map((l, j) => <li key={j}>{l}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
